/**
 * wsr-api queue-observability client (WSRPDM-0013, contract §3).
 *
 * Raw DTOs, no `unwrap()` — wsr-api has no `{success,data}` envelope
 * (contract §0.5), mirrors `./tenants.ts`. These endpoints are 2s
 * server-cached; the caller (`usePolling`) polls at ~5s, never faster, so
 * every poll tick hits a fresh cache entry.
 */
import { request } from '../client';
import type { QueueActiveJobsView, QueueSummaryView, QueueUpcomingView } from './types';

const BASE = '/admin/platform/queue';

/** GET /admin/platform/queue/summary (contract §3.1). */
export async function getSummary(): Promise<QueueSummaryView> {
  return request<QueueSummaryView>('GET', `${BASE}/summary`);
}

/**
 * GET /admin/platform/queue/jobs (contract §3.2). No query params — the
 * backend applies no server-side filter; tenant/job-type filtering happens
 * client-side in the Queue screen.
 */
export async function getJobs(): Promise<QueueActiveJobsView> {
  return request<QueueActiveJobsView>('GET', `${BASE}/jobs`);
}

/** GET /admin/platform/queue/upcoming — platform-wide, soonest first, at most 50 rows. */
export async function getUpcoming(): Promise<QueueUpcomingView> {
  return request<QueueUpcomingView>('GET', `${BASE}/upcoming`);
}
